import { Macro } from '../types/Macro';
import { MacroParts } from '../types/MacroParts';

export const macroPartsToMacro = (parts: MacroParts): Macro => {
  const content: string[] = [];
  const { token, operator, value } = parts;

  if (token) content.push(`${token}:`);
  if (operator) content.push(`${operator}(`);
  if (value) {
    const q = /\W/.test(value) ? '"' : '';
    content.push(`${q}${value}${q}`);
  }
  if (operator) content.push(`)`);

  return { ...parts, segment: content.join('') };
};
